import { useContext } from "react";
import AuthContext from "../context/authProvider";

const useAuth = () => {
    console.log("useAuth mounted");
    return useContext(AuthContext);
}

export default useAuth;